import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-card-content',
  templateUrl: './card-content.component.html',
  standalone: false,
})
export class CardContentComponent {
  @HostBinding('class') styles = 'block w-full p-4 sm:px-6 sm:py-4';
}
